import { mapAuditDates } from '@mkp/shared/data-access';
import { LegalEntity, LegalEntityDto } from '@mkp/legal-entity/models';
import { isLegalEntityState } from './legal-entity.helpers';
import { LegalEntityState } from '@mkp/shared/models';

// just in case we find an unknown value, should not happen
const DEFAULT_LEGAL_ENTITY_STATE = LegalEntityState.InVerification;

export const mapLegalEntityDtosToLegalEntities = (dtos: LegalEntityDto[]) =>
  dtos.map((dto: LegalEntityDto) => mapLegalEntityDtoToLegalEntity(dto));

export const mapLegalEntityDtoToLegalEntity = (dto: LegalEntityDto): LegalEntity => ({
  id: dto.id,
  externalSource: dto.externalSource,
  externalId: dto.externalId,
  name: dto.name,
  state: getLegalEntityState(dto.state),
  employeeCountFrom: dto.employeeCountFrom,
  employeeCountTo: dto.employeeCountTo,
  industry: {
    de: dto._embedded.industry.name.de,
    en: dto._embedded.industry.name.en,
    fr: dto._embedded.industry.name.fr,
  },
  claimed: dto.claimed,
  industryId: dto.industryId,
  address: dto.address,
  settings: { staffingAgency: dto.settings?.staffingAgency ?? false },
  _version: dto._version,
  _embedded: dto._embedded,
  ...mapAuditDates(dto),
});

const getLegalEntityState = (state: string): LegalEntityState => {
  if (!isLegalEntityState(state)) {
    console.error(`Unknown Legal Entity State: ${state}`);
    return DEFAULT_LEGAL_ENTITY_STATE;
  }

  return state;
};
